import { useGetProgramTerminals, type ProgramTerminal } from '../api/useProgram';
import { DataTable, type Column } from './DataTable';

const columns: Column<ProgramTerminal>[] = [
  { key: 'uid', header: 'Terminal ID', className: 'font-mono text-xs text-gray-400', cell: (t) => `${t.uid.slice(0, 8)}…`, copyValue: (t) => t.uid },
  { key: 'merchant', header: 'Merchant', className: 'text-gray-900', cell: (t) => t.merchant_name, copyValue: (t) => t.merchant_name },
];

export const ProgramTerminalsTable = ({ uid }: { uid: string }) => {
  const { data, isLoading, isError } = useGetProgramTerminals(uid);
  const terminals = data?.payload?.terminals ?? [];

  return (
    <DataTable
      columns={columns}
      rows={terminals}
      rowKey={(t) => t.uid}
      isLoading={isLoading}
      isError={isError}
      errorLabel="Failed to load terminals."
      emptyLabel="No terminals."
    />
  );
};
